var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCheck(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 10,
    viewBox: "0 0 12 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.74537 9.39136C4.48469 9.39198 4.22644 9.34032 3.98545 9.23934C3.74445 9.13836 3.52544 8.99003 3.34098 8.80288L0.627012 6.06361C0.245712 5.68999 0.0215382 5.18092 0.00147278 4.64308C-0.0185926 4.10524 0.167008 3.58039 0.519377 3.17852C0.701718 2.98263 0.9208 2.82579 1.16372 2.71726C1.40663 2.60873 1.66847 2.5507 1.93381 2.54657C2.19914 2.54245 2.4626 2.59232 2.70868 2.69325C2.95475 2.79418 3.17845 2.94412 3.36661 3.13425L4.72743 4.50909L8.53826 0.637134C8.90598 0.249717 9.40701 0.0219448 9.93635 0.00155745C10.4657 -0.0188299 10.9823 0.169746 11.3778 0.527768C11.5706 0.713034 11.7249 0.935633 11.8318 1.18245C11.9386 1.42926 11.9957 1.6953 11.9998 1.96489C12.0038 2.23448 11.9547 2.50218 11.8554 2.75219C11.7561 3.00221 11.6085 3.2295 11.4214 3.42068L6.15489 8.79507C5.97036 8.98414 5.75079 9.13419 5.50886 9.23653C5.26693 9.33888 5.00743 9.3915 4.74537 9.39136Z",
    fill: "#00C483"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheck);
export default __webpack_public_path__ + "static/media/check.1fe4d8db83f567086b3dd90f89cdff3c.svg";
export { ForwardRef as ReactComponent };